import cx from 'classnames';
import { forwardRef, useCallback } from 'react';

import { useForwardRef } from '@trello/dom-hooks';
import { useSharedStateSelector } from '@trello/shared-state';
import type { ListTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { cardDragAndDropState } from './cardDragAndDropState';

import styles from './ListCardDropPreview.less';

type ListCardDropPreviewProps = {
  className?: string;
};

export const ListCardDropPreview = forwardRef<
  HTMLDivElement,
  ListCardDropPreviewProps
>(({ className }, ref) => {
  const forwardedRef = useForwardRef(ref);
  const previewHeight = useSharedStateSelector(
    cardDragAndDropState,
    useCallback((state) => state.previewHeight, []),
  );

  return (
    <div
      ref={forwardedRef}
      className={cx(styles.dropPreview, className)}
      style={{ height: previewHeight }}
      data-testid={getTestId<ListTestIds>('list-card-drop-preview')}
    />
  );
});
